import { render, staticRenderFns } from "./infoCompany.vue?vue&type=template&id=41dd035f&scoped=true&"
import script from "./infoCompany.vue?vue&type=script&lang=js&"
export * from "./infoCompany.vue?vue&type=script&lang=js&"
import style0 from "./infoCompany.vue?vue&type=style&index=0&id=41dd035f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dd035f",
  null
  
)

export default component.exports